import { PropsWithChildren } from "react";

import { NotificationContext } from "./NotificationContext";
import { useNotificationProvider } from "./useNotificationProvider";

export const NotificationProvider = ({ children }: PropsWithChildren) => {
  const notification = useNotificationProvider();

  return (
    <NotificationContext.Provider value={notification}>
      {children}
    </NotificationContext.Provider>
  );
};